import React from 'react'
import { Link } from 'react-router-dom'
import { Button, Card } from 'react-bootstrap'

export default function QuestionnairesEmpty() {
  return (
    <Card style={{ border: '0px' }}>
      <Card.Body>
        <h5 className='font-weight-bold'>
          No Questionnaires to display.
        </h5>
        <div className='my-4'>
          When you have Questionnaires they will appear here. Start by creating a questionnaire below.
        </div>
        <Button as={Link} to='/questionnaires/create' variant='outline-primary' className="px-5">
          Create Questionnaire
        </Button>
      </Card.Body>
    </Card>
  )
}
